import { CardContent, CardHeader, Typography, CardTitle, Button, Card } from '@ui/components';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import * as React from 'react';

import { SendApplicationModal } from './send-application-modal/send-application-modal';

type SendApplicationProps = React.HTMLAttributes<HTMLDivElement>;

export const SendApplication: React.FC<SendApplicationProps> = (props) => {
  const { t } = useTranslation();

  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <Card {...props}>
      <CardHeader>
        <CardTitle>{t('HELP.SEND_APPLICATION_TITLE')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Typography variant="labelMediumMedium" className="text-weak">
          {t('HELP.SEND_APPLICATION_DESCRIPTION_1')}
        </Typography>
        <Typography variant="labelMediumMedium" className="text-weak mt-4">
          {t('HELP.SEND_APPLICATION_DESCRIPTION_2')}
        </Typography>

        <HasPermission permissionFeature="HELP_SEND_A_TICKET" permissionType="WRITE">
          <Button onClick={() => setModalOpen(true)} className="mt-16">
            {t('HELP.SUBMIT_APPLICATION')}
          </Button>
        </HasPermission>
      </CardContent>

      <SendApplicationModal onOpenChange={setModalOpen} open={modalOpen} />
    </Card>
  );
};
